import React from 'react';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const rootElement = document.getElementById('root');

const tree = (
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>
);

// Use hydrateRoot when the prerender (`react-snap`) has populated the DOM,
// otherwise fall back to createRoot for normal dev/runtime.
if (rootElement.hasChildNodes()) {
  ReactDOM.hydrateRoot(rootElement, tree);
} else {
  const root = ReactDOM.createRoot(rootElement);
  root.render(tree);
}

reportWebVitals();
